import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

// By default, tiptap adds new lines to paragraphs and bullet lists when copying.
// This extension overrides that behavior to remove excessive new lines, while also
// preserving the structure of the document and the allowed marks.
export const ClipboardCopyHandler = Extension.create({
    name: 'clipboardCopyHandler',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('clipboardCopyHandler'),
                props: {
                    clipboardTextSerializer: (slice) => {
                        const text = slice.content.textBetween(
                            0, // Start position in the fragment
                            slice.content.size, // End position in the fragment
                            '\n\n', // String to add between blocks (paragraphs, etc.)
                            '\n', // String to add for explicit soft returns
                        );

                        // Any consecutive sequence of 2+ newlines becomes a single newline
                        return text.replace(/\n{2,}/g, '\n');
                    },
                },
            }),
        ];
    },
});
